// import React, { useState } from "react";
// import "./contact.css";
// import { FaMapMarkerAlt, FaEnvelope, FaPhoneAlt, FaFacebookF, FaDribbble, FaBehance, FaInstagram, FaLinkedin } from "react-icons/fa";




// const ContactForm = () => {
//   const [name, setName] = useState('');
// const [email, setEmail] = useState('');
// const [location, setLocation] = useState('');
// const [budget, setBudget] = useState('');
// const [subject, setSubject] = useState('');
// const [message, setMessage] = useState('');


// const handleSubmit = async (e) => {
//   e.preventDefault();

//   const formData = {
//     name,
//     email,
//     location,
//     budget,
//     subject,
//     message,
//   };

//   console.log("🚀 Sending form data to backend:", formData);

//   try {
//     const response = await fetch('https://eylocoin.site/portfoilo/contact.php', {
//       method: 'POST',
//       headers: {
//         'Content-Type': 'application/json',
//       },
//       body: JSON.stringify(formData),
//     });


//     console.log("✅ Fetch response received:", response);

//     // const result = await response.json();
//     // console.log("📦 Parsed result:", result);

//     // if (result.success) {
//     //   alert("Message sent successfully!");
//     // } else {
//     //   alert("Something went wrong.");
//     // }
//   } catch (err) {
//     console.error("❌ Fetch error:", err);
//     alert("Error sending message: " + err.message);
//   }
// };


//   return (
//     <div className="contact-container">
//       <div className="contact-left">
//         <h2>Let's Build Something Awesome Together</h2>
//         <p>
//         Whether it’s a web platform, smart device, or an autonomous robot — I’d love to hear about your project and see how I can help bring it to life.
//         </p>

//         <div className="contact-info">
//           <div className="info-box">
//             <FaMapMarkerAlt className="icon" />
//             <div>
//               <p className="label">Address:</p>
//               <p>Kottakkal,kerala,india</p>
//             </div>
//           </div>
//           <div className="info-box">
//             <FaEnvelope className="icon" />
//             <div>
//               <p className="label">My Email:</p>
//               <p>mohamedsafvanvp@gmail.com</p>
//             </div>
//           </div>
//           <div className="info-box">
//             <FaPhoneAlt className="icon" />
//             <div>
//               <p className="label">Call Me Now:</p>
//               <p>+91 8086945415</p>
//             </div>
//           </div>
//         </div>

//         <div className="social-iconss">
//           <a href="#"><FaFacebookF /></a>
//           <a href="#"><FaDribbble /></a>
//           <a href="#"><FaBehance /></a>
//           <a href="#"><FaInstagram /></a>
//           <a href="#"><FaLinkedin /></a>
//         </div>
//       </div>

//       <div className="contact-right">
//       <p>There are many variations of passages of  avalilable,<br />But majority have suffered alte</p>
//         <form onSubmit={handleSubmit}>

//           {/* <label>Name*</label> */}
//           <input type="text" placeholder="Name*" value={name} onChange={(e) => setName(e.target.value)} required />

//           {/* <label>Email*</label> */}
//           <input type="email" placeholder="Email*" value={email} onChange={(e) => setEmail(e.target.value)} required />

//           {/* <label>Location</label> */}
//           <input type="text" placeholder="Location*" value={location} onChange={(e) => setLocation(e.target.value)} />

//           <div className="row">
//             <div className="budget">
//               {/* <label>Budget*</label> */}
//               <input type="text" placeholder="Budget*" value={budget} onChange={(e) => setBudget(e.target.value)} />
//             </div>
//             <div>
//               {/* <label>Subject*</label> */}
//               <input type="text" placeholder="Subject*" value={subject} onChange={(e) => setSubject(e.target.value)} />
//             </div>
//           </div>

//           {/* <label>Message*</label> */}
//           <input placeholder="Message*" value={message} onChange={(e) => setMessage(e.target.value)} />

//           <button type="submit">
//             Submit <span>→</span>
//           </button>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default ContactForm;
import React, { useState } from "react";
import "./contact.css";
import {
  FaMapMarkerAlt,
  FaEnvelope,
  FaPhoneAlt,
  FaFacebookF,
  FaDribbble,
  FaBehance,
  FaInstagram,
  FaLinkedin,
  FaPhone,
  FaGithub,
} from "react-icons/fa";

import ReCAPTCHA from 'react-google-recaptcha';
const ContactForm = () => {
  const url="https://eylocoin-site.stackstaging.com/"
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [location, setLocation] = useState('');
  const [budget, setBudget] = useState('');
  const [subject, setSubject] = useState('');
  const [message, setMessage] = useState('');
  const [verified, setVerified] = useState(false);
  const [verifiedToken, setVerifiedToken] = useState('');

  const handleCaptchaChange = (value) => {
    console.log('Captcha value:', value);
    if (value) {
      setVerified(true);
      setVerifiedToken(value); // ✅ Save the token!
    } else {
      setVerified(false);
      setVerifiedToken('');
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!window.grecaptcha) {
      alert("reCAPTCHA not loaded!");
      return;
    }

    window.grecaptcha.ready(() => {
      window.grecaptcha.execute('6LfNv4ArAAAAALGPyJD7zgBoHkJP3itRdS4YNwtB', { action: 'submit' }).then(async (token) => {
        const formData = {
          name,
          email,
          location,
          budget,
          subject,
          message,
          'g-recaptcha-response': token
        };

        console.log("🚀 Sending form data:", formData);

        try {
          const response = await fetch(`${url}portfoilo/contact.php`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(formData),
          });

          const data = await response.json();
          console.log("✅ Server response:", data);

          if (data.success) {
            alert("Message sent successfully!");
          } else {
            alert("Failed: " + data.error);
          }

        } catch (err) {
          console.error(err);
          alert("Error sending message");
        }
      });
    });
  };


  return (
    <div className="contact-container">
      {/* Left Side - Contact Info */}
      <div className="contact-left">
        <h2>Let’s Build Something Awesome Together</h2>
        <p>
          Whether it’s a <strong>web application</strong>, smart device, or an autonomous robot —
          I’d love to hear about your project and help bring it to life.
        </p>

        <div className="contact-info">
          <div className="info-box">
            <FaMapMarkerAlt className="icon" />
            <div>
              <p className="label">Address:</p>
              <p>Kottakkal, Kerala, India</p>
            </div>
          </div>
          <div className="info-box">
            <FaEnvelope className="icon" />
            <div>
              <p className="label">Email:</p>
              <p>mohamedsafvanvp@gmail.com</p>
            </div>
          </div>
          <div className="info-box">
            <FaPhoneAlt className="icon" />
            <div>
              <p className="label">Phone:</p>
              <p>+91 8086945415</p>
            </div>
          </div>
        </div>

        <div className="social-iconss">
          <a
            href="https://github.com/safvan13058"
            target="_blank"
            rel="noopener noreferrer"
            className="github-btn"
          >
            <FaGithub />
          </a>
          {/* <a href="#"><FaDribbble /></a> */}
          <a href="tel:+918086945415"><FaPhone /></a>
          <a
            href="https://www.instagram.com/safvan_13058"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <FaInstagram />
          </a>
          <a
            href="https://www.linkedin.com/in/mohamedsafvanvp"
            target="_blank"
            rel="noopener noreferrer"
            className="social-icon"
          >
            <FaLinkedin />
          </a>
        </div>
      </div>

      {/* Right Side - Contact Form */}
      <div className="contact-right">
        <p>
          I usually reply within 24 hours. Let’s start a conversation and turn your vision into a working solution.
        </p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Your Name*"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />

          <input
            type="email"
            placeholder="Your Email*"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <input
            type="text"
            placeholder="Your Location"
            value={location}
            onChange={(e) => setLocation(e.target.value)}
          />

          <div className="row">
            <div className="budget">
              <input
                type="text"
                placeholder="Estimated Budget"
                value={budget}
                onChange={(e) => setBudget(e.target.value)}
              />
            </div>
            <div>
              <input
                type="text"
                placeholder="Subject*"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                required
              />
            </div>
          </div>

          <input
            placeholder="Your Message*"
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            required
          />

          <button type="submit" >
            Submit <span>→</span>
          </button>




        </form>
      </div>
    </div>
  );
};

export default ContactForm;
